import { snapshot } from 'valtio'
import { type AxiosError } from 'axios'
import { virtualTerminalProxy } from '../../routes/app/virtual-terminal/index/virtualTerminalProxy'
import { VirtualTerminalProxyFormFieldNamesEnum } from '../types/virtualTerminalProxyFormFieldNamesEnum'
import { buildAxiosInstance, SOURCE_NAME } from '../utils/apiUtils'
import { convertToCentValue } from '../utils/formattingUtils'
import { GtagEvents, gtmTrackButtonPress } from '../utils/gtmUtils'

interface Response {
  data: {
    transaction: {
      id: string
    }
  } | null
  error: string | null
  errorCode: { description: string, merchantAction: string }
}

export async function executeAddCardSaleByToken (): Promise<void> {
  try {
    gtmTrackButtonPress(GtagEvents.TRANSACTION_SUBMIT)

    virtualTerminalProxy.apiCallAddCardSaleByToken.loading = true
    virtualTerminalProxy.apiCallAddCardSaleByToken.error = null
    const { form: { values }, customer, customerCard } = snapshot(virtualTerminalProxy)

    const sendReceipt = !!values.email

    const response = await buildAxiosInstance().post<Response>('/api/sales/create_cc_from_saved_card', {
      addressOne: values.streetAddressOne || null,
      addressTwo: values.streetAddressTwo || null,
      amountCents: convertToCentValue(Number(values.amount), 'USD'),
      amountCurrencyType: 'USD',
      city: values.city || null,
      countryCode: values.countryCode || 'US',
      customerCardId: customerCard?.id,
      customerId: customer?.id,
      email: sendReceipt ? values.email : null,
      invoiceNumber: values[VirtualTerminalProxyFormFieldNamesEnum.InvoiceNumber],
      notes: values.notes,
      postalCode: values.postalCode || null,
      shouldSendReceipt: sendReceipt,
      sourceName: SOURCE_NAME,
      state: values.state || null
    })
    if (response.data.data) {
      virtualTerminalProxy.completed = true
      virtualTerminalProxy.lastTransactionId = response.data.data.transaction.id
    } else {
      virtualTerminalProxy.apiCallAddCardSaleByToken.error = response.data.error
    }
  } catch (e) {
    if (e instanceof Error) {
      virtualTerminalProxy.apiCallAddCardSaleByToken.error = e.message
      virtualTerminalProxy.apiCallAddCardSaleByToken.errorMessage = (e as AxiosError<Response>).response?.data.error
      virtualTerminalProxy.apiCallAddCardSaleByToken.errorCode = (e as AxiosError<Response>).response?.data.errorCode
    }
  } finally {
    virtualTerminalProxy.apiCallAddCardSaleByToken.loading = false
  }
}
